__webpack_require__.p = "/change-in-supply-vs-change-in-quantity-supplied/";